window.$ = window.jQuery = require('jquery')
import { createApp } from 'vue'

import Calculations from './mixins/Calculations';
import FormValidators from './mixins/FormValidators';

import PageSection from './components/PageSection.vue';
import PageWhiteSection from './components/PageWhiteSection.vue';
import Action from './components/Action.vue';
import OurTeam from './components/OurTeam.vue';
import Coach from './components/Coach.vue';
import ImageText from './components/ImageText.vue';
import TextImage from './components/TextImage.vue';
import StepsTabs from './components/StepsTabs.vue';
import ActionBanner from './components/ActionBanner.vue';
import BannerImage from './components/BannerImage.vue';
import Testimonials from './components/Testimonials.vue';
import SubscriberForm from './components/SubscriberForm.vue';

// Calculators
//================================================== 
import OtherCalculator from './components/calculators/OtherCalculator.vue';
import EmrCalculator from './components/calculators/EmrCalculator.vue';
import WealthCalculator from './components/calculators/WealthCalculator.vue';
import retirementCalculator from './components/calculators/RetirementCalculator.vue';

// Goal page level individual calculators
//================================================== 
import pageRetirementCalculator from './components/pageCalculators/RetirementPgCalculator.vue';
import pageOtherCalculator from './components/pageCalculators/OtherPgCalculator.vue';
import pageWealthCalculator from './components/pageCalculators/WealthPgCalculator.vue';

import custPageOtherCalculator from './components/pageCalculators/CustOtherPgCalculator.vue';
import custPageEmrCalculator from './components/pageCalculators/CustEmrPgCalculator.vue';

//Modals
//================================================== 
import ScheduleSession from './components/modals/ScheduleSession.vue';
import BookSession from './components/modals/BookSession.vue';
import Persona from './components/modals/Persona.vue';
import BecomePartner from './components/modals/BecomePartner.vue';
import ScheduleTour from './components/modals/ScheduleTour.vue';

//Partners
import TextBanner from './components/TextBanner.vue';
import LottieImage from './components/LottieImage.vue';
import TextLeftImageRight from './components/TextLImageR.vue';
import ImageLeftTextRight from './components/ImageLTextR.vue';
import LeftTextBanner from './components/LeftTextBanner.vue';
import CallPartner from './components/CallPartner.vue';


const app = createApp({});
app.component('page-section', PageSection);
app.component('page-white-section', PageWhiteSection);
// Inner structure
app.component('image-text', ImageText);
app.component('text-image', TextImage);
app.component('steps-tabs', StepsTabs);
app.component('action-banner', ActionBanner);
app.component('banner-image', BannerImage);
app.component('testimonials',Testimonials);
app.component('subscriber-form', SubscriberForm);

// Calculator
//================================================== 
app.component('other-calculator', OtherCalculator);
app.component('wealth-calculator', WealthCalculator);
app.component('retirement-calculator', retirementCalculator);
app.component('emergency-calculator', EmrCalculator);

// Goal page level individual calculators
//================================================== 
app.component('retirementpage-calculator', pageRetirementCalculator);
app.component('otherpage-calculator', pageOtherCalculator);
app.component('wealthpage-calculator', pageWealthCalculator);

app.component('custotherpage-calculator', custPageOtherCalculator);
app.component('custemrpage-calculator', custPageEmrCalculator);


// Modals
//================================================== 
app.component('action', Action);
app.component('ourteam', OurTeam);
app.component('coach', Coach);
app.component('schedule-session-modal', ScheduleSession);
app.component('book-session', BookSession);
app.component('persona-modal', Persona);
app.component('partner-modal', BecomePartner);
app.component('tour-modal', ScheduleTour);

//Partners
app.component('text-banner', TextBanner);
app.component('lottie-image', LottieImage);
app.component('text-l-image-r', TextLeftImageRight);
app.component('image-l-text-r', ImageLeftTextRight);
app.component('left-text-banner', LeftTextBanner);
app.component('call-partner', CallPartner);

// Vue.component('page-section', require('./components/PageSection.vue').default);
// Vue.component('action', require('./components/Action.vue').default);
app.mixin(Calculations);
app.mixin(FormValidators);

app.config.globalProperties.$token = "";
if( document.querySelector("meta[name='csrf-token']").getAttribute('content') !== null )
    app.config.globalProperties.$token = document.querySelector("meta[name='csrf-token']").getAttribute('content');

app.mount('#hfApp');
require('./bootstrap');
